<app-mobile-menu></app-mobile-menu>

<!-- Add all page content inside this div if you want the side nav to push page content to the right (not used if you only want the sidenav to sit on top of the page -->
<main id="main" [ngClass]="{'show-menu': mobileMenuService.isOpen}">
  <app-header></app-header>

  <router-outlet></router-outlet>

  <app-trust-pilot></app-trust-pilot>
  <!-- <app-marketing-boxes></app-marketing-boxes> -->
  <app-footer></app-footer>
  <app-cookie-popup></app-cookie-popup>
  <div class="background-overlay" (click)="mobileMenuService.closeMenu()"></div>
</main>